var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 32l0 192 256 0 0-192L160 32zm-32 0c0-17.7 14.3-32 32-32L416 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-192zM48 160l48 0 0 32-48 0c-8.8 0-16 7.2-16 16l0 112 512 0 0-112c0-8.8-7.2-16-16-16l-48 0 0-32 48 0c26.5 0 48 21.5 48 48l0 112 0 16 0 16 0 112c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 352l0-16 0-16L0 208c0-26.5 21.5-48 48-48zM544 352L32 352l0 112c0 8.8 7.2 16 16 16l480 0c8.8 0 16-7.2 16-16l0-112z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngage);
export default __webpack_public_path__ + "static/media/engage.1ccdeeb065a85109ffb64aa877cf88be.svg";
export { ForwardRef as ReactComponent };